import Link from 'next/link';
import css from './styles/guide-link-button.module.css';
import ComputerWindowIcon from 'static/svgs/icon/computer-window-icon';
import BookIcon from 'static/svgs/icon/book-icon';
import ArticleIcon from 'static/svgs/icon/article-icon';

export const GuideLinkButtonSection: React.FC<React.PropsWithChildren> = ({
  children,
}) => <div className={css.wrapper}>{children}</div>;

type GuideLinkButtonProps = {
  text: string;
  href: string;
  variant: 'purple' | 'blue' | 'orange';
};

const GuideLinkButton: React.FC<GuideLinkButtonProps> = ({
  text,
  href,
  variant,
}) => (
  <Link href={href}>
    <a className={css[variant]}>
      {text}
      {svg[variant]}
    </a>
  </Link>
);

const svg = {
  purple: <ComputerWindowIcon fill="var(--background-strong)" />,
  blue: <BookIcon fill="var(--background-strong)" />,
  orange: <ArticleIcon fill="var(--background-strong)" />,
};

export default GuideLinkButton;
